import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        headingTitle: {
            textStyle: {base: 'head-large', lg: 'head-xlarge'},
            borderBottom: 'small',
            paddingY: {base: remCalc(16), lg: remCalc(24)},
            fontWeight: 'medium',
        },
        headingTitleBox: {
            textStyle: {base: 'head-medium'},
            fontWeight: 'medium',
        },
        productRegistrationBox: {
            flexDirection: 'column',
            padding: remCalc(24),
            border: 'small',
            borderColor: 'border.light',
            borderRadius: 'base',

            description: {
                textStyle: 'body-medium',
                maxW: {base: '100%', lg: remCalc(400)},
            },
        },
        registerButton: {
            maxW: {base: '100%', lg: remCalc(230)},
        },
        tableContainer: {
            border: 'small',
            borderColor: 'border.light',
            borderRadius: 'large.cbase',
            whiteSpace: 'wrap',
        },
        tableRow: {
            Td: {
                MaxW: remCalc(150),
            },
        },
        ticketCardGrid: {
            gridTemplateColumns: '1.2fr 1fr',
            gridTemplateRows: 'repeat(5, auto)',
            gridTemplateAreas: `
                "ticket Ticket"
                "entryDate EntryDate"
                "product Product"
                "repairShippingDate RepairShippingDate"
                "status Status"
            `,
            gridColumnGap: remCalc(24),
            gridRowGap: remCalc(10),
            padding: remCalc(20),
            border: 'small',
            borderRadius: 'large.base',
            borderColor: 'border.light',
        },
        ticketCardHeader: {
            textStyle: {base: 'body-small'},
            fontWeight: 'bold',
        },
        ticketCardData: {
            textStyle: 'body-xsmall',
        },
    },
}
